<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description : 404
  -->
  <div class="main">
    <img :src="image" />
    <div class="title">你访问的页面找不到了</div>
    <el-button type="primary" @click="goMain" plain round> 返回首页 </el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      image: require("@/assets/images/404.png"),
    };
  },
  methods: {
    goMain() {
      location.href = "/";
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  text-align: center;
}
.title {
  margin-bottom: 36px;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 2px;
  text-align: center;
}
</style>